<template>
	<fieldset :disabled="loading > 0">
		<b-form-row>
			<b-col cols="12" sm="6" md="8">
				<form @submit.prevent.stop="saveField('goal', parseFloat(goal||0)||0, 'Goal')">
					<b-input-group prepend="Goal" class="mt-1" size="sm">
						<b-form-input type="number" v-model.number="goal" min="0" step="any"></b-form-input>
						<b-input-group-append>
							<b-input-group-text>{{currencyCode}}</b-input-group-text>
							<b-button type="submit" variant="primary">Set</b-button>
						</b-input-group-append>
					</b-input-group>
				</form>
			</b-col>
			<b-col>
				<b-icon v-show="saving > 0" icon="circle-fill" animation="throb" class="mt-2"></b-icon>
			</b-col>
		</b-form-row>
		<div class="goal-actions">
			<form @submit.prevent.stop="saveField('amount', parseFloat(amount||0)||0, 'Amount')" class="goal-set">
				<b-input-group prepend="Amount" class="mt-1" size="sm">
					<b-form-input type="number" no-wheel v-model.number="amount" min="0" step="any"></b-form-input>
					<b-input-group-append>
						<b-input-group-text>{{currencyCode}}</b-input-group-text>
						<b-button type="submit" variant="primary">Set</b-button>
					</b-input-group-append>
				</b-input-group>
			</form>
			<form @submit.prevent.stop="addAmount" class="goal-add">
				<b-input-group class="mt-1" size="sm">
					<b-form-input type="number" v-model.number="amountAdd" step="any"></b-form-input>
					<b-input-group-append>
						<b-input-group-text>{{currencyCode}}</b-input-group-text>
						<b-button type="submit" variant="secondary" :disabled="!amountAdd">Add</b-button>
					</b-input-group-append>
				</b-input-group>
			</form>
		</div>
	</fieldset>
</template>

<script>
export default {
	data() { return {
		loading: 0,
		saving: 0,
		currencyCode: '',
		amount: 0,
		amountAdd: '',
		goal: 0,
		subId: null,
	}},
	watch: {
		loading(val) { this.$emit('loading', val > 0); },
	},
	mounted() {
		this.loadData();
	},
	beforeDestroy() {
		this.subId && this.$socket.unsubscribe(this.subId);
	},
	methods: {
		async loadData() {
			this.loading++;
			try {
				const [user, settings] = await Promise.all([
					this.$api.get('userData'),
					this.$api.get('widgetSettings/gift-goal'),
				]);
				this.currencyCode = user?.currency_code || '';
				this.amount = Math.round(parseFloat(settings?.amount)||0);
				this.goal = settings?.goal || 0;

				this.subId = this.$socket.subscribe(user?.widget_hash, {
					widgetSettingsFieldChange: msg => {
						if(msg.widgetType != 'gift-goal') return;
						if(msg.field == 'amount') this.amount = Math.round(parseFloat(msg.value)||0);
						if(msg.field == 'goal') this.goal = msg.value;
					},
				});
			} catch(e) {
				if(e.message == 'Subscription required') return;
				this.$bvToast.toast(`Could not load gift goal settings: ${e.error||e.toString()}`, { title: 'Error', variant: 'danger', solid: true });
			} finally {
				this.loading--;
			}
		},
		async saveField(field, value, name, add) {
			this.saving++;
			try {
				await this.$api.post(`widgetSettings/gift-goal/${encodeURIComponent(field)}`, { value, add });
				if(add) this.reloadAmount();
			} catch(err) {
				this.$bvToast.toast(`Could not update ${name}: ${err.error||err.toString()}`, { title: 'Error', variant: 'danger', solid: true });
			} finally {
				this.saving--;
			}
		},
		async reloadAmount() {
			try {
				const settings = await this.$api.get('widgetSettings/gift-goal');
				this.amount = Math.round(parseFloat(settings?.amount)||0);
			} catch(e) { /* ignore */ }
		},
		addAmount() {
			this.saveField('amount', parseFloat(this.amountAdd||0)||0, 'Amount', true);
			this.amountAdd = '';
		},
	},
};
</script>

<style scoped>
/* Amount/Set + Add lay out side by side, but wrap (Add drops under Set) based on the
   available width of THIS component — its parent panel — not the viewport. */
.goal-actions {
	display: flex;
	flex-wrap: wrap;
	/* row gap = the old per-form mb-3 (Set↔Add when wrapped); column gap = the old 5px+5px gutter. */
	gap: 1rem 10px;
	/* Replaces the goal form's old mb-3. No bottom margin: it overflows the fixed-height dashboard panel, and following content supplies its own spacing. */
	margin-top: 1rem;
}
.goal-actions > .goal-set { flex: 1 1 180px; }
.goal-actions > .goal-add { flex: 1 1 130px; }
</style>
